<template>
    <div>
        <div class="message">
            <div class="box" @click="openPhone" @mouseleave="closePhone">
                <img src="@/assets/images/index/message-phone.png" alt="">
                <span>电话</span>
            </div>
            <div class="box" @click="openMessage">
                <img src="@/assets/images/index/message-chat.png" alt="">
                <span>咨询留言</span>
            </div>
            <div class="close" @click="gotoTop">
                <img src="@/assets/images/index/message-btn.png" alt="">
            </div>
        </div>
        <!-- 手机弹框 -->
        <transition enter-active-class="animate__animated animate__fadeInRight"
            leave-active-class="animate__animated animate__fadeOutRight">
            <div class="phone-box" v-if="showPhone">
                <div class="phone-box-main">
                    <span>座机联系方式</span>
                    <span>(023)-62757988</span>
                </div>
                <div class="phone-box-main">
                    <span>手机联系</span>
                    <span>131 0123 5756</span>
                </div>
            </div>
        </transition>
        <!--聊天弹框 -->
        <transition enter-active-class="animate__animated animate__fadeInRight "
            leave-active-class="animate__animated animate__fadeOutRight">
            <div class="chat-box" v-if="showMessage" @mouseleave="closeMessage">

                <div class="chat-box-title">
                    <img src="@/assets/images/index/message-icon.png" alt="" class="icon"><span>溢希恩真</span>
                    <img src="@/assets/images/index/message-close.png" alt="" class="close"
                        @click="showMessage = false">
                </div>
                <div class="chat-box-content" @click="showEmoji = false">
                    <div class="message-list">
                        <div class="message-item" v-for="(item, index) in messageList" :key="index">
                            <!-- <div class="message-item-time">
                                <img src="@/assets/images/index/message-line.png" alt="" class="line">
                                <span>11:22</span>
                            </div> -->
                            <div class="message-item-main" :class="{ 'message-item-right': !item.icon }">
                                <img :src="item.icon" alt="" v-if="item.icon">
                                <span>{{ item.message }}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="chat-box-footer">
                    <div class="footer-top">
                        <EmojiPicker hide-search="false" native="true" manualClose="true" @select="onVue3EmojiPicker"
                            v-show="showEmoji" :static-texts="{ placeholder: '搜索单元格' }"
                            style="position: absolute;top: -16.25rem;left: 0;z-index: 9999; width: 16.25rem;height:16.25rem;">
                        </EmojiPicker>
                        <img src="@/assets/images/index/message-footer-icon.png" alt="" @click="showEmoji = !showEmoji">
                        <img src="@/assets/images/index/message-footer-photo.png" alt="">
                        <span>转人工客服</span>
                    </div>
                    <div class="footer-main">
                        <el-input v-model="textarea" type="textarea" placeholder="请输入留言" @click="showEmoji = false" />
                    </div>
                    <div class="footer-btn">
                        <button @click="sendMes">发送</button>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import companyIcon from '@/assets/images/index/message-icon.png'
import { ref } from 'vue'
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";
const showPhone = ref(false)
const showMessage = ref(false)
const textarea = ref('')
const timerOne = ref(null)
const timerTwo = ref(null)
const messageList = ref([
    {
        icon: companyIcon,
        time: '11:22',
        message: '您好，我是重庆溢希恩真官方客服，如因业务繁忙不能及时回复您，您可以留下姓名+联系方式+公司名，我们会安排项目经理给您详细介绍。'
    },

])
// 发送信息
const sendMes = () => {
    if (textarea.value == '') {
        ElMessage.error('请输入内容')
        return
    }
    console.log(textarea.value)
    messageList.value.push({
        time: '11:22',
        message: textarea.value
    })
    textarea.value = ''
}
const openPhone = () => {
    showPhone.value = true
    showMessage.value = false
}
const openMessage = () => {
    showMessage.value = true
    showPhone.value = false
}
const closePhone = () => {
    if (timerOne.value) {
        clearTimeout(timerOne.value)
    }
    timerOne.value = setTimeout(() => {
        showPhone.value = false
        showEmoji.value = false
    }, 5000)
}
const closeMessage = () => {
    if (timerTwo.value) {
        clearTimeout(timerTwo.value)
    }
    timerTwo.value = setTimeout(() => {
        showMessage.value = false
    }, 5000)
}
// 表情包模块
const showEmoji = ref(false)
const onVue3EmojiPicker = (e) => {
    console.log('onVue3EmojiPicker', e);
    textarea.value += e.i
}
// 返回顶部按钮
const gotoTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}
</script>

<style lang="less" scoped>
:deep(.el-textarea__inner) {
    box-shadow: none;
    height: 100% !important;
    font-size: .875rem;
}

.message {
    position: fixed;
    bottom: 6.25rem;
    right: 1.875rem;
    width: 5rem;
    height: 11.875rem;
    background: #FFFFFF;
    box-shadow: 0px .25rem 1.5rem .0625rem rgba(0, 0, 0, 0.08);
    border-radius: .25rem;
    border: 1px solid #E9EBF2;
    z-index: 9999;
    display: flex;
    flex-direction: column;

    .box {
        width: 100%;
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: .875rem;

        span {
            margin-top: .375rem;
        }

        img {
            width: 1.375rem;
            height: 1.375rem;
        }
    }

    .close {
        border-top: .0625rem solid #E9EBF2;
        width: 100%;
        height: 1.875rem;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: .875rem;
            height: .5rem;
        }
    }
}

.phone-box {
    position: fixed;
    bottom: 13.75rem;
    right: 8.125rem;
    width: 13.75rem;
    height: 9.5rem;
    background: #FFFFFF;
    box-shadow: 0px 1rem 1.875rem .0625rem rgba(0, 0, 0, 0.06);
    border-radius: .25rem;
    // border: .0625rem solid #E7E9F0;
    // border-right: none;
    z-index: 9999;
    padding: 1.0625rem;

    .phone-box-main {
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:first-child {
            border-bottom: 1px solid #E9EBF2;
        }

        span {
            &:first-child {
                font-size: .875rem;
                color: #333333;
                margin-bottom: .25rem;
            }

            &:last-child {
                font-size: 1rem;
                color: #000000;
                font-weight: bold;
            }
        }
    }

    &::after {
        content: '';
        width: 0px;
        height: 0px;
        border: .9375rem solid;
        border-left: .9375rem solid #fff;
        border-right: .9375rem solid transparent;
        border-bottom: .9375rem solid transparent;
        border-top: .9375rem solid transparent;

        /*给绝对定位，根据需求设置三角形的位置*/
        position: absolute;
        bottom: 1.25rem;
        right: -1.75rem;
    }

}

.chat-box {
    position: fixed;
    bottom: 6.25rem;
    right: 0px;
    width: 23.75rem;
    height: 33.75rem;
    z-index: 9999;
    background: #fff;
    box-shadow: 0px .25rem 1.5rem .0625rem rgba(0, 0, 0, 0.08);

    .chat-box-title {
        width: 100%;
        height: 3.75rem;
        background: @xtxColor;
        display: flex;
        align-items: center;
        padding-left: 1.25rem;
        position: relative;

        span {
            font-size: 1rem;
            color: #fff;
        }

        .icon {
            width: 2.5rem;
            height: 2.5rem;
            margin-right: .625rem;
        }

        .close {
            position: absolute;
            right: 1.25rem;
            width: .6875rem;
            height: .6875rem;
        }

    }

    .chat-box-content {
        width: 100%;
        height: 20rem;
        background: #F5F6F8;
        padding: 1.5rem;
        overflow-y: scroll;

        .message-list {
            // overflow-y: scroll;
            width: 100%;

            .message-item {
                display: flex;
                flex-direction: column;
                position: relative;

                .message-item-time {
                    position: relative;
                    margin-bottom: .625rem;

                    span {
                        position: absolute;
                        top: .25rem;
                        left: 50%;
                        transform: translateX(-50%);

                    }

                    .line {
                        width: 100%;
                        height: .0625rem;
                    }

                }

                .line {
                    width: 100%;
                    height: .0625rem;
                }


                .message-item-main {
                    display: flex;
                    margin-bottom: 1.25rem;

                    img {
                        width: 2.5rem;
                        height: 2.5rem;
                        margin-right: .625rem;
                    }

                    span {
                        width: 11.25rem;
                        display: inline-block;
                        padding: 1rem;
                        background: #fff;
                        font-size: .875rem;
                        text-align: left;

                    }
                }

                .message-item-right {
                    position: relative;

                    span {
                        margin-left: 8.75rem;
                        // position: absolute;
                        word-wrap: break-word;
                        overflow-wrap: break-word;

                    }
                }

            }
        }
    }

    .chat-box-footer {
        width: 100%;
        height: 10rem;
        background: #fff;
        border-top: 1px solid #F5F6F8;

        .footer-top {
            width: 100%;
            height: 2.875rem;
            padding-left: 1.375rem;
            display: flex;
            align-items: center;
            font-size: .8125rem;
            color: #BFBFBF;
            position: relative;

            img {
                width: 1.5625rem;
                height: 1.5625rem;
                margin-right: 1.25rem;
            }

            span {
                position: absolute;
                right: 1.25rem;
            }
        }

        .footer-main {
            width: 100%;
            height: 4.375rem;

            padding-left: 1.5rem;
            padding-top: .625rem;
            padding-right: 1.5rem;
            padding-bottom: 0.625rem;
        }

        .footer-btn {
            width: 100%;
            height: 2.8125rem;

            display: flex;
            align-items: center;
            position: relative;

            button {
                position: absolute;
                right: 1rem;
                width: 3.75rem;
                height: 2rem;
                background: #FFFFFF;
                border-radius: .1875rem;
                border: 1px solid #BFBFBF;
                color: #BFBFBF;

                &:hover {
                    color: @xtxColor;
                    border: 1px solid @xtxColor;
                }
            }
        }
    }
}
</style>